module.exports = __webpack_public_path__ + "img/serve_sdk.216b2e6c.png";